import { Link, Navigate, useLocation, useParams, useSearchParams } from 'react-router-dom'
import { scopeFromParams, workbenchHref } from '../navigation/context'
import { ErrorState } from '../state'
import ContextWorkbench from './ContextWorkbench'

/** Old queue links keep their task context while landing in the three current queues. */
export default function ContextWorkbenchRoute() {
  const { surface, taskId } = useParams()
  const location = useLocation()
  const [params] = useSearchParams()
  const scopeParams = new URLSearchParams(params)
  if (!scopeParams.has('scope')) {
    scopeParams.set(
      'scope',
      scopeParams.get('subchain')
        ? 'subchain'
        : scopeParams.get('fund')
          ? 'fund'
          : scopeParams.get('client')
            ? 'client'
            : 'all'
    )
  }
  let scope
  try {
    scope = scopeFromParams(scopeParams)
  } catch (error) {
    return (
      <main className="wb">
        <ErrorState what="Workbench context" error={error} />
        <Link
          className="vbtn pri"
          to={workbenchHref(
            { kind: 'all' },
            params.get('queue') === 'evidence'
              ? 'evidence'
              : params.get('queue') === 'chase'
                ? 'chase'
                : 'book'
          )}
        >
          Open all funds work
        </Link>
        <Link to="/v2/funds">Choose a fund ›</Link>
      </main>
    )
  }
  if (surface === 'other-ops') {
    const next = new URLSearchParams(scopeParams)
    next.set('queue', 'book')
    next.set('recovery', '1')
    if (taskId) next.set('task', taskId)
    return <Navigate to={`/v2/workbench?${next}#additional-work`} replace />
  }
  const queue =
    surface === 'chase-request'
      ? 'chase'
      : surface === 'ownership-verification' || surface === 'reconciliation'
        ? 'evidence'
        : 'book'
  const next = new URLSearchParams(scopeParams)
  if (!next.has('queue')) next.set('queue', queue)
  // A task in the route is the explicit selection, including on old queue links.
  // Normalize once so every downstream pane and refresh reads the same identity.
  if (taskId) next.set('task', taskId)
  if (taskId || next.toString() !== params.toString()) {
    const path = taskId ? '/v2/workbench' : location.pathname
    return <Navigate to={`${path}?${next}${location.hash}`} replace />
  }
  return <ContextWorkbench scope={scope} />
}
